<template>
    <div>
        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                fit
                stripe
                highlight-current-row
                class="data-table"
                @row-click="openEdit"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'year',label:'Year'},
                        {prop:'updateTime',label:'Updated Time',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :visible.sync="dialogVisible"
                width="40%">
            <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="100px">
                <el-form-item prop="year" label="Year">
                    <el-input-number v-model="form.year" :min="2019" :max="2222"></el-input-number>
                </el-form-item>

                <el-form-item label="Holiday" prop="dayList">
                    <el-input v-model="form.dayList" type="textarea" autosize
                              placeholder="Enter list of holiday, format: DDMM, Holiday Name (e.g. 0101, New Year)">

                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData">Save</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import {holidayList, holidayCreate, holidayUpdate} from '@/api/SettingAPI'

    export default {
        name: "Holiday",
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                form: {},
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    year: [
                        {required: true, message: 'Year is required', trigger: 'blur'},
                    ],
                    dayList: [
                        {required: true, message: 'Please input the holidays ', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, holidayList)
            },
            openCreate() {
                this.form = {}
                this.dialogVisible = true
            },
            openEdit(row) {
                this.form = this.$copy(row);
                this.dialogVisible = true
            },
            saveData() {
                const action = this.form.id ? holidayUpdate : holidayCreate;
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        action(this.form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible=false
                            })
                    }
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
